import * as Scrivito from "scrivito";
import { localizeAttrList } from "^/utils/localizeAttribute";
import IconEditorTab from "^/Components/ScrivitoExtensions/IconEditorTab";
import { LaIconEditorTab } from "^/Components/ScrivitoExtensions/LaIconEditorTab";
import iconWidgetIcon from "../../assets/images/icon_widget.svg";

Scrivito.provideEditingConfig("IconWidget", {
  title: "Icon",
  thumbnail: iconWidgetIcon,
  attributes: localizeAttrList(["size", "alignment", "link"], "IconWidget"),
  propertiesGroups: [
    {
      title: "FA Icon",
      component: IconEditorTab,
      key: "iconEditorTab",
    },
    {
      title: "LA Icon",
      component: LaIconEditorTab,
      key: "laIconEditorTab",
    },
    {
      title: "Optional attributes",
      properties: [
        "size",
        "sizeTablet",
        "sizeMobile",
        "alignment",
        "link",
        "iconColor",
      ],
    },
  ],
  initialContent: {
    icon: "las la-hippo",
    size: "300",
    sizeTablet: "300",
    sizeMobile: "300",
    alignment: "center",
  },
  titleForContent: (widget) => widget.get("icon").replace(/^la-/, ""),
});
